module.exports = __webpack_public_path__ + "media/images/reviews/circle_review_avatar_1-f7d689af756a47a597ea900446eb6682.png";